import { Services } from '@sigma-frontend-libs/commons'

import { currentTab, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'PaymentsTemplate',

  mixins: [ currentTab(Services.payments) ],

  computed: {
    canGetPayments() {
      return this.checkPermissions(`advanced.${Services.payments}.get`, permissionPresets.meUp)
    },
    canGetRecurrentPayments() {
      return this.checkPermissions(`advanced.${Services.recurrentPayments}.get`, permissionPresets.meUp)
    },

    items() {
      const result = []
      if (this.canGetPayments) {
        result.push(Services.payments)
      }
      if (this.canGetRecurrentPayments) {
        result.push(Services.recurrentPayments)
      }

      return result
    }
  },

  render
}
